import { useEffect, useRef, useState } from "react";
import Button from "../../../Custom/Button/Button";
import CustomSelect from "./CustomSelect";
import { useGlobalContext } from "../../../../Context/Context";
import DateSelect from "./DateSelect";
import CustomSelectMultiple from "./CustomSelectMultiple";

const vrsteDokumentaAll = [
  {
    id: "1",
    name: "IZDAVANJE - REVERS",
    key: "REVERS"
  },
  {
    id: "2",
    name: "RAZDUZENJE",
    key: "RAZDUZENJE"
  },
  {
    id: "3",
    name: "DODAVANJE U MAGACIN",
    key: "MAGACIN"
  },
  {
    id: "4",
    name: "OTPIS (RASHOD)",
    key: "OTPIS"
  }
];
const zaposleniAll = [
  {
    id: "1",
    name: "Pera Peric"
  },
  {
    id: "2",
    name: "Mika Mikic"
  },
  {
    id: "3",
    name: "Laza Lazic"
  }
];
const radnaMestaAll = [
  {
    id: "1",
    name: "Tesar"
  },
  {
    id: "2",
    name: "Vozac"
  },
  {
    id: "3",
    name: "Zidar"
  }
];

const danasnjiDatum = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const dokumentEmpty = {
  vrstaSredstva: {
    id: -1,
    name: ""
  },
  vrstaDokumenta: {
    id: -1,
    name: "",
    key: ""
  },
  brojDokumenta: "",
  datum: danasnjiDatum,
  zaposleni: [],
  radnaMesta: []
};

function SredstvaLZOForm({ fileNewDocument, vrstaSredstva, setCurrentTab }) {
  const [dokument, setDokument] = useState(dokumentEmpty);
  const [isDodajNoviText, setIsDodajNoviText] = useState(false);
  const [fileDocument, setFileDocument] = useState(fileNewDocument);

  const fileInputRef = useRef();

  const {
    dictionary,
    setIsGlobalnoDodavanjeDokumenta,
    setIsLZOClicked,
    setFolderDokumentCurrentState,
    setLZOVrstaDokumenta
  } = useGlobalContext();

  useEffect(() => {
    setDokument((prev) => ({ ...prev, vrstaSredstva }));
  }, [vrstaSredstva]);

  useEffect(() => {
    setFileDocument(fileNewDocument);
  }, [fileNewDocument]);

  const onChange = (newValue, field) => {
    setDokument((prev) => ({ ...prev, [field]: newValue }));
  };

  const onChangeSelectMultiple = (newValue, field) => {
    const newValues = dokument[field].find((d) => d.id === newValue.id)
      ? dokument[field].filter((d) => d.id !== newValue.id)
      : [...dokument[field], newValue];
    setDokument((prev) => ({ ...prev, [field]: newValues }));
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setFileDocument(file);
    setIsDodajNoviText(false);
  };

  const handleSave = () => {
    console.log(dokument);
    console.log(fileDocument);
    setIsDodajNoviText(true);
    setDokument((prev) => ({
      ...dokumentEmpty,
      vrstaSredstva: prev.vrstaSredstva,
      vrstaDokumenta: prev.vrstaDokumenta
    }));
  };

  const handleDodajNovi = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleAzuriraj = () => {
    setCurrentTab("FOLDER");
    setIsLZOClicked(true);
    setFolderDokumentCurrentState("AZURIRANJE");
    setIsGlobalnoDodavanjeDokumenta(false);
    setLZOVrstaDokumenta(dokument.vrstaDokumenta.key);
  };

  const handleOdustani = () => {
    setIsGlobalnoDodavanjeDokumenta(false);
  };

  const isDisabledSacuvaj =
    !dokument.vrstaSredstva.name ||
    !dokument.vrstaDokumenta.name ||
    !dokument.brojDokumenta ||
    dokument.zaposleni.length === 0 ||
    dokument.radnaMesta.length === 0;

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "flex-end"
        }}
      >
        <CustomSelect
          label={dictionary["vrstaDokumenta"]}
          allValues={vrsteDokumentaAll}
          selectedValue={dokument.vrstaDokumenta}
          onSelectChange={(value) => onChange(value, "vrstaDokumenta")}
        />
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["brojDokumenta"]}
          </div>
          <input
            value={dokument.brojDokumenta}
            onChange={(e) => onChange(e.target.value, "brojDokumenta")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>
        <div>
          <DateSelect
            label="DATUM"
            selectedValue={dokument.datum}
            onSelectChange={(value) => onChange(value, "datum")}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <CustomSelectMultiple
          label="IME I PREZIME"
          allValues={zaposleniAll}
          selectedValues={dokument.zaposleni}
          onSelectChange={(value) => onChangeSelectMultiple(value, "zaposleni")}
        />
        <CustomSelectMultiple
          label="RADNO MESTO"
          allValues={radnaMestaAll}
          selectedValues={dokument.radnaMesta}
          onSelectChange={(value) =>
            onChangeSelectMultiple(value, "radnaMesta")
          }
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={{ padding: "10px" }}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={
            isDodajNoviText
              ? handleDodajNovi
              : isDisabledSacuvaj
                ? undefined
                : handleSave
          }
          style={{ opacity: !isDodajNoviText && isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileInputChange}
          />
          <Button
            isDisabled={!isDodajNoviText && isDisabledSacuvaj}
            activation={true}
            style={{ padding: "10px" }}
          >
            {isDodajNoviText ? "+ DODAJ NOVI" : dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
      {dokument.vrstaDokumenta.name !== "" && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px"
          }}
        >
          <div onClick={handleAzuriraj}>
            <Button activation={true} style={{ padding: "10px" }}>
              AZURIRAJ
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SredstvaLZOForm;
